import { CustomModal } from "@/component/CustomModal/page";
import { GENERAL_TEXT, URLS } from "@/lib/constants";

export const ModalComponent = ({
  toggle,
  setShowModal,
  showModal,
  HOW_TO_USE,
  setToggle,
}) => {
  const toggleMap = {
    watch: GENERAL_TEXT.SUMMARY,
    score: GENERAL_TEXT.SCORE,
    fourm: GENERAL_TEXT.FOURM,
    mos: GENERAL_TEXT.MOS,
  };

  const activeKey = Object.keys(toggleMap).find((key) => toggle[key]);
  const title = toggleMap[activeKey] || "";

  return (
    <CustomModal
      title={title}
      className="edit-modal"
      open={showModal}
      onCancel={() => {
        setShowModal(false);
        setToggle({
          ...toggle,
          watch: false,
          score: false,
          fourm: false,
          mos: false,
        });
      }}
      footer={null}
    >
      <div>
        {toggle.watch && (
          <>
            <p className="modal-text">
              Stocks in Tykr are classified as either On Sale, Watch, or
              Overpriced. Only 15% of stocks achieve an On Sale rating in Tykr.
            </p>
            <p className="modal-text mt-16">How the Summary works:</p>
            <div className="mt-16 modal-summery">
              {HOW_TO_USE.map((item, index) => (
                <div
                  key={index}
                  className={item.note ? "d-flex align-items-center" : ""}
                >
                  <div className={item.note ? "m-0" : "m-0"}>
                    <p className={`potential_data mb-0 ${item.className}`}>
                      <span className="fs-16">{item.label}</span>
                    </p>
                  </div>
                  {item.note && (
                    <p className={`ml-8 gray-color fs-16 mb-0`}>{item.note}</p>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
        {toggle.score && (
          <>
            <p className="modal-text">
              The score represents the overall financial strength of a stock.
              <span className="modal-text-span">
                The higher the score, the safer the investment.
              </span>
            </p>
            <div className="mt-16">
              <ul className="padding-start">
                <li>
                  <div className="d-flex">
                    <p className="modal-text">
                      <span className="modal-text-span">100&nbsp;</span>= Safe
                      (This is a financially strong stock with a high
                      probability of seeing the share price increase)
                    </p>
                  </div>
                </li>
                <li className="mt-4">
                  <div className="d-flex">
                    <p className="modal-text">
                      <span className="modal-text-span">0&nbsp;</span>= Not safe
                      (This is a financially weak stock with a high probability
                      of seeing the share price decrease)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="mt-16 ml-0 mr-0 second-hint">
              <p className="modal-text m-0`">
                <span className="modal-text-span">💡 Pro Tip:</span> If a stock
                has strong financials, it’s proving to investors like you and me
                that it’s a good investment. In other words, if you invest in a
                company that’s working hard to keep financials extremely
                healthy, you have a high probability of making money
              </p>
            </div>
          </>
        )}
        {toggle.fourm && (
          <>
            <p className="modal-text">
              If On Sale is Good and Overpriced is Bad, how do you determine
              when to buy and sell? The answer is the 4M Confidence Booster.
              When you click on a stock within Tykr, you will find the 4M score.
            </p>
            <div className="mt-16">
              <ul className="padding-start">
                <li>
                  <div className="d-flex">
                    <p className="modal-text">
                      <span className="modal-text-span fit-content">
                        80-100
                      </span>
                      &nbsp; = High confidence 🎉 Yay! This is an overall strong
                      stock. It passes all 4Ms! Only buy this stock if it aligns
                      with your personal investment goals.
                    </p>
                  </div>
                </li>
                <li>
                  <div className="d-flex">
                    <p className="modal-text">
                      <span className="modal-text-span fit-content">60-79</span>
                      &nbsp; = Moderate confidence 🤔 Alert! There may be better
                      stocks in the market. Only buy this stock if you truly
                      believe the company will improve!
                    </p>
                  </div>
                </li>
                <li className="mt-4">
                  <div className="d-flex">
                    <p className="modal-text">
                      <span className="modal-text-span fit-content">
                        0-59&nbsp;
                      </span>{" "}
                      = Low confidence 🚨 Warning! There are better stocks in
                      the market. Due to the low score, you should consider
                      looking at other stocks.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="mt-16 ml-0 mr-0 second-hint">
              <p className="modal-text">
                <span className="modal-text-span">💡 Note:</span> As an
                investor, you need to look at the 4Ms to determine if a stock is
                a good or bad investment. If you do this manually, it can take
                you hours, if not days, of research. Fortunately, Tykr reduced
                that down to seconds!
              </p>
            </div>
          </>
        )}
        {toggle.mos && (
          <>
            <p className="modal-text">
              <span className="modal-text-span">
                The higher the Margin of Safety, the higher the potential
                returns you can make.
              </span>
              Tykr calculations are open source for personal use. See our
              calculations{" "}
              <a
                className="blue-6"
                href={URLS.TYKR_CALCULATION}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .
            </p>
            <div className="mt-16">
              <p className="modal-text">
                Think of it like buying groceries. When you go shopping for
                food, do you want to pay full price or do you want to find a
                deal? Personally, I never like to pay full price on groceries
                and I never like to pay full price on stocks!
              </p>
            </div>
            <div className="mt-16 ml-0 mr-0 second-hint">
              <p className="modal-text">
                <span className="modal-text-span">💡 Example:</span> If the
                Share Price is $100 and the Fair Value is $200, that means the
                MOS is 50%. ($100 is 50% off $200). If the Share Price is $100
                and the Fair Value is $400, that means the MOS is 75%. ($100 is
                75% off $400).
              </p>
            </div>
          </>
        )}
      </div>
    </CustomModal>
  );
};
